<template>
  <div>

    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>

    <!--USER LINK-->
    <UserLink :user="notification.data.user"/>

    <!--CREATED-->
    <div>
      {{ $t('notifications.policy.document_ready_to_publish') }}
      <span class="text-info"> {{notification.data.policyDocument.name}}</span>
      <span> {{ $t('system.in') }}</span>

      <span> {{ $t('maintenance.policies.log.title') }}</span>

      <router-link
        :to="{ name: 'policies.view', params: { slug: notification.data.policy.slug, client: notification.data.policy.client }}"
      >
        {{notification.data.policy.name}}
      </router-link>


    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'PolicyDocumentReadyToPublishNotification',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    components: {
      UserLink,
      Avatar
    },
    props: {
      notification: {},
      changes: false
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }
        }
        return words.join(' ');
      }
    },
    created() {

    }
  }
</script>

<style scoped lang="scss">

</style>
